import { styled } from 'styled-components';
export const StyledCodeFieldContainer = styled.div `
  min-height: ${({ $minHeight }) => `${$minHeight}px`};
  max-height: ${({ $maxHeight }) => `${$maxHeight}px`};
  display: flex;

  .cm-editor {
    border-radius: 8px;
    border: 1px solid ${({ $error, theme }) => $error && theme.colors.critical100};
    overflow: hidden;
    flex: auto;
    outline: none;

    &.cm-focused {
      outline: none;
      ${({ theme, $error }) => ($error ? theme.shadows.error : theme.shadows.focus)};
      border-color: ${({ theme, $error }) => !$error && theme.colors.main};
    }

    &:not(.cm-focused) {
      &:hover {
        border-color: ${({ theme, $error }) => !$error && theme.colors.grey70_1};
      }

      &:not(:hover) {
        border-color: ${({ theme, $error }) => !$error && theme.colors.grey30_1};
      }
    }
  }
`;
